// extracted by mini-css-extract-plugin
export default {"colorPickerCover":"ColorPicker__colorPickerCover___GLGYr","colorPickerPopover":"ColorPicker__colorPickerPopover___2eyRC"};